import Dialog from "@mui/material/Dialog";

interface props {
	newValue: boolean;
	open: boolean;
	onClose: (updated: boolean) => void;
}

export const ConfirmMembershipChange = ({ newValue, open, onClose }: props) => {
	return (
		<Dialog open={open}>
			<div
				className="flex flex-col items-center p-8 gap-4"
				style={{ width: 500 }}
			>
				<p className="ch-m-text ch-em-text-navy text-center">
					{newValue ? "Enable Membership" : "Disable Membershp"}
				</p>
				<p className="pb-3 text-center">
					{newValue
						? "You are going to enable membership in the Our Medical app"
						: "You are going to disable membership in the Our Medical app"}
				</p>

				<div className="flex gap-4">
					<button
						className="ch-button ch-button-primary justify-center"
						style={{ width: 200 }}
						onClick={() => onClose(false)}
					>
						Go Back
					</button>
					<button
						className="ch-button ch-button-secondary justify-center"
						style={{ width: 200 }}
						onClick={() => onClose(true)}
					>
						{newValue ? "Enable Membership" : "Disable Membershp"}
					</button>
				</div>
			</div>
		</Dialog>
	);
};
